import { createContext, useContext } from "react";
import type { ModifyBufferApi } from "../hooks/useModifyBuffer";

const ModifyBufferContext = createContext<ModifyBufferApi | null>(null);

export function ModifyBufferProvider({
  value,
  children,
}: Readonly<{
  value: ModifyBufferApi;
  children: React.ReactNode;
}>) {
  return (
    <ModifyBufferContext.Provider value={value}>
      {children}
    </ModifyBufferContext.Provider>
  );
}

/** Returns the modify buffer — null when not wrapped in a provider (non-modify UI paths). */
export function useModifyBufferOptional(): ModifyBufferApi | null {
  return useContext(ModifyBufferContext);
}
